import { BillOfMaterialsLineItem, Customer, HotListOrderItem, PlasticsHardwareItem, PlasticsMaterial, PlasticsOrderedProduct, Product, ProductVersion, VendorHardwareData } from "@prism/prism-shared";


export interface PlasticsMoldingTask {
    id: string;
    productId: string;
    moldId: string;
    totalQuantity: number;
    completedQuantity: number;
    orderedProductId: string;
    status: PlasticsMoldingTaskStatus;
    completedOn: Date | null;
    note: string;
    kitNeeded: boolean;
    hotListOrderItemId: string | null;
}

export interface DisplayPlasticsMoldingTask {
    task: PlasticsMoldingTask;
    version: ProductVersion | null;
    orderedProduct: PlasticsOrderedProduct | null;
    customer: Customer | null;
    hotListOrderItem?: HotListOrderItem | null;
}


export interface MoldingTaskDependantData {
    // transactions: ProductInventoryTransaction[];
    product: Product;
    moldingTask: PlasticsMoldingTask;
    productVersion: ProductVersion;
    lineItemHardwareItems: PlasticsHardwareItem[];
    vendorHardwareData: VendorHardwareData[];
    lineItemProducts: Product[];
    lineItemProductVersions: ProductVersion[];
    lineItemMaterials: PlasticsMaterial[];
    lineItems: BillOfMaterialsLineItem[];
}


export enum PlasticsMoldingTaskStatus {
    // should change to released
    IN_PROGRESS = "in progress",
    Complete = "complete",
    Canceled = "canceled",
}


export const toDisplayMoldingTasks = (
    tasks: PlasticsMoldingTask[],
    productIdToReleasedProductVersionDict: Record<string, ProductVersion>,
    customerDict: Record<string, Customer>,
    orderedProducts: PlasticsOrderedProduct[],
    hotListOrderItemDict: Record<string, HotListOrderItem> = {},
): DisplayPlasticsMoldingTask[] => {
    return tasks.map((task) => {
        const hotListOrderItem = task.hotListOrderItemId ? hotListOrderItemDict[task.hotListOrderItemId] || null : null;

        // placeholder
        if (!task.productId) {
            return {
                task,
                version: null,
                orderedProduct: null,
                customer: null,
                hotListOrderItem,
            }
        }

        if (!task.orderedProductId) {
            return {
                task,
                version: productIdToReleasedProductVersionDict[task.productId],
                orderedProduct: null,
                customer: null,
                hotListOrderItem,
            }
        }
        const orderedProduct = orderedProducts.find(op => op.id === task.orderedProductId) as PlasticsOrderedProduct;

        if (!orderedProduct) {
            // this shouldnt happen because we should be loading them all
            return {
                task,
                orderedProduct,
                version: productIdToReleasedProductVersionDict[task.productId],
                customer: null,
                hotListOrderItem,
            }
        }

        const displayMixingTask: DisplayPlasticsMoldingTask = {
            task,
            orderedProduct,
            version: productIdToReleasedProductVersionDict[task.productId],
            customer: customerDict[orderedProduct.customerId],
            hotListOrderItem,
        }

        return displayMixingTask;
    })
        .sort((a, b) => {
            const aCompleted = a.task.status === PlasticsMoldingTaskStatus.Complete;
            const bCompleted = b.task.status === PlasticsMoldingTaskStatus.Complete;
            if (aCompleted && !bCompleted) {
                return 1;
            }
            if (!aCompleted && bCompleted) {
                return -1;
            }
            return 0;
        })


}
